import React, { useState, useCallback, useEffect } from "react";
import API from "../common/api.js";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import PhonenumberInput from "react-phone-number-input/input";
import { isValidPhoneNumber } from 'react-phone-number-input'
import "react-phone-number-input/style.css";

function AddFaxPage() {
    const [errMsg, setErrMsg] = useState(null);
    const [saving, setSaving] = useState(false);
    const [phonenumber, setPhonenumber] = useState("");
    const [user, setUser] = useState(null);
    const [team, setTeam] = useState(null);
    const [users, setUsers] = useState([]);
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(true);
    let history = useHistory();

    const valid = phonenumber && isValidPhoneNumber(`${phonenumber}`) && (user !== null || team !== null);

    const loadData = useCallback(async () => {
        const [usersData, teamsData] = await Promise.all([API.getUsers(), API.getTeams()]);

        if (teamsData) {
            setTeams(teamsData);
        } else {
            setErrMsg("Unable to load team data from server");
        }

        if (usersData) {
            setUsers(usersData);
        } else {
            setErrMsg("Unable to load user data from server");
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        loadData();
    }, [loadData]);

    async function save() {
        setSaving(true);
        const success = await API.createFaxNumber(phonenumber, user?.value, team?.value);
        if (success) {
            history.push("/settings");
        } else {
            setErrMsg("ERROR: Saving fax failed! Please retry.");
            setSaving(false);
        }
    }

    const errmsgEl = errMsg ? <div className="ui error message">{errMsg}</div> : null;

    const possibleUsers = users && users.map((u) => ({ value: u.user_id, label: u.name }));
    const possibleTeams = teams && teams.map((t) => ({ value: t.team_id, label: t.name }));

    if (loading) {
        return (
            <div>
                <div className="ui active inline loader" style={{ marginTop: 20 }}></div>
            </div>
        );
    } else {
        return (
            <div>
                {errmsgEl}
                <h1 className="ui header">Add New Fax</h1>
                <div className="ui form segment">
                    <div className="field">
                        <label htmlFor="name">Phone number:</label>
                        <div className="w-88">
                            <PhonenumberInput country="US" value={phonenumber} onChange={setPhonenumber} />
                        </div>
                    </div>
                    <div className="field">
                        <label htmlFor="email">Assign to user:</label>
                        <Select
                            options={possibleUsers}
                            placeholder="Select a user"
                            className="w-88"
                            value={user}
                            onChange={(option) => setUser(option)}
                            isClearable={true}
                        />
                    </div>
                    <div className="field">
                        <label htmlFor="email">Assign to team:</label>
                        <Select
                            options={possibleTeams}
                            placeholder="Select a team"
                            className="w-88"
                            value={team}
                            onChange={(option) => setTeam(option)}
                            isClearable={true}
                        />
                    </div>

                    <button
                        className={classNames("ui primary button", { loading: saving, disabled: !valid })}
                        onClick={save}
                    >
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

export default AddFaxPage;
